import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CustomerService } from '../services/customer.service';
import { TreeNode } from 'primeng/components/common/treenode';
import { ICustomer } from '../models/ICustomer';
import { StrategiesPermissionsService } from '../../strategies/services/strategies-permissions.service';

@Component({
  selector: 'app-select-institution',
  templateUrl: './select-institution.component.html',
  styleUrls: ['./select-institution.component.scss']
})
export class SelectInstitutionComponent implements OnInit {
  searchTerms$ = new Subject<string>();
  searchResults: any;
  customers: TreeNode[];
  childrenLoading = false;
  searchInputValue: string;
  numberOfSearchResults = 15;

  constructor(
    private strategiesPermissionsService: StrategiesPermissionsService,
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.customerService.search(
      this.searchTerms$,
      this.numberOfSearchResults,
      this.strategiesPermissionsService.isUserSuperAdmin()
    ).subscribe(response => this.searchResults = response);
    this.route.data.subscribe(data => this.customers = this.buildTreeNodeArray(data.customers));
  }

  selectInstitutionFromSearch(customer: ICustomer) {
    if (customer.customerActiveFlag) {
      this.customerService.institution = customer;
      this.selectInstitutionFinal();
    }
  }

  selectInstitutionFromTree(customer: ICustomer) {
    this.customerService.institution = customer;
    this.selectInstitutionFinal();
  }

  private selectInstitutionFinal() {
    this.strategiesPermissionsService.populateUserInstitutionRoleAndPermissions();
    this.router.navigate([`/strategies/dashboard/${this.customerService.institution.id}`]);
  }

  loadChildren(event: any) {
    if (!event.node.children) {
      this.childrenLoading = true;
      this.customerService.getChildrenWithChildStatus(event.node.data.id).subscribe(
        res => {
          this.childrenLoading = false;
          event.node.children = this.buildTreeNodeArray(res);
          event.node.styleClass = this.getNodeStyleClass(event.node.selectable, true);
        },
        err => {
          this.childrenLoading = false;
          console.log(err); // TODO integrate error messages
        }
      );
    } else {
      // children already loaded previously, just apply the style
      event.node.styleClass = this.getNodeStyleClass(event.node.selectable, true);
    }
  }

  collapseChildren(event: any) {
    event.node.styleClass = this.getNodeStyleClass(event.node.selectable, false);
  }

  hasAddressInfo(customer: ICustomer): boolean {
    return !!(customer.city && customer.state && customer.postalCode);
  }

  private buildTreeNodeArray(customers: any) {
    return customers.map(
      customer => {
        return {
          label: customer.name,
          data: customer,
          leaf: customer.childCount === 0,
          styleClass: this.getNodeStyleClass(this.customerActiveFlagToBoolean(customer.customerActiveFlag), false),
          selectable: this.customerActiveFlagToBoolean(customer.customerActiveFlag)
        };
      });
  }

  private getNodeStyleClass(active: boolean, expanded: boolean): string {
    let styleClass = '';
    if (!active) {
       styleClass = ' inactive';
    }
    if (expanded) {
      styleClass += ' expanded';
    }

    return styleClass;
  }

  // TODO backend team should be sending boolean as booleans not strings, request change and remove function
  private customerActiveFlagToBoolean(it: string): boolean {
    return it === 'true' ? true : false;
  }

}
